import { render, staticRenderFns } from "./system-control.vue?vue&type=template&id=aa3edd14&scoped=true&"
import script from "./system-control.vue?vue&type=script&lang=ts&"
export * from "./system-control.vue?vue&type=script&lang=ts&"
import style0 from "./system-control.vue?vue&type=style&index=0&id=aa3edd14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3edd14",
  null
  
)

export default component.exports